<template>
  <div style="width: 100%">
    <!-- Pesquisar -->
    <v-row
      class="justify-end"
      dense
    >
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn
            color="primary"
            @click="pesquisar"
            v-on="{ ...onTooltip }"
          >
            Pesquisar
          </v-btn>
        </template>
        <span>Clique para pesquisar</span>
      </v-tooltip>
    </v-row>

    <!-- Monitoramento -->
    <v-row v-if="relatorio" class="justify-center mx-1">
      <component
        :is="tipoMonitoramento"
        :relatorio="relatorio"
        :ano="`${anoAtual}`"
        is-geral
      />
    </v-row>
  </div>
</template>

<script>
import Data from '@/modules/data';
import Cadastro from '@/components/monitoramento/perfil/relatorio/cadastro/RelatorioPerfilGeralCadastro';
import Formacao from '@/components/monitoramento/perfil/relatorio/formacao/RelatorioPerfilGeralFormacao';
import Profissional from '@/components/monitoramento/perfil/relatorio/profissional/RelatorioPerfilGeralProfissional';
import Interesse from '@/components/monitoramento/perfil/relatorio/interesse/RelatorioPerfilGeralInteresse';
import Preferencia from '@/components/monitoramento/perfil/relatorio/preferencia/RelatorioPerfilPreferencia';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const monitoramentoRepository = RepositoryFactory.get('monitoramento');

export default {
  name: 'RelatorioPerfilGeral',

  components: {
    Cadastro,
    Formacao,
    Profissional,
    Interesse,
    Preferencia,
  },

  props: {
    selecaoUnidade: {
      type: Object,
      default: () => ({
        macro: false,
        unidades: [],
        categoria: 'TODOS',
      }),
      required: true,
    },
    tipoMonitoramento: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      relatorio: null,
    };
  },

  computed: {
    payload() {
      return {
        isMacro: this.selecaoUnidade.macro,
        categoria: this.selecaoUnidade.categoria,
        unidades: this.selecaoUnidade.unidades.map((u) => ({ id: u.id })),
      };
    },
    anoAtual() {
      return Data.get().year();
    },
  },

  methods: {
    pesquisar() {
      if (this.selecaoUnidade.unidades.length > 0) {
        this.relatorio = null;
        monitoramentoRepository.getRelatorioPerfil(this.payload).then((response) => {
          this.relatorio = response.data;
          this.$store.dispatch('app/success', { response, message: '' });
        });
      } else {
        this.$store.dispatch('app/showMessage', {
          cor: 'warning',
          texto: 'É necessário selecionar, pelo menos, uma unidade!',
        });
      }
    },
  },
};
</script>
